import { httpClient } from '@api/client/http';

export interface NotificationItem {
  id: number;
  title: string;
  message: string;
  is_read: 'Yes' | 'No';
  module: string;
  code: string | null;
  redirectionRequired: boolean;
  ref_data: unknown;
  created_at: string;
}

export interface NotificationsListResponse {
  unread_notifications_count: number;
  notifications: NotificationItem[];
}

const BASE = '/workshop/notifications';

/** GET /workshop/notifications/notifications_list */
export async function fetchNotificationsList(): Promise<NotificationsListResponse> {
  const { data } = await httpClient.get<{
    success: number;
    message: string;
    errors: string[];
    data: NotificationsListResponse;
  }>(`${BASE}/notifications_list`);

  return data.data;
}

/** POST /workshop/notifications/mark_as_read */
export async function markNotificationsAsRead(): Promise<void> {
  await httpClient.post(`${BASE}/mark_as_read`);
}
